<template>
  <div class="w-full">
    <div
      class="nav h-20 flex flex-row border-b border-gray-100 px-4 sm:px-6 justify-center sm:justify-between items-center w-full"
    >
      <img
        class="h-14"
        src="https://res.cloudinary.com/dcsensx8u/image/upload/v1644320869/Hotspot_logo_5.png"
        alt="Tizeti Hotspot Logo"
      />
      <!--      <img class="w-32" src="https://res.cloudinary.com/dcsensx8u/image/upload/v1644320869/Hotspot_logo_5.png" alt="Tizeti Hotspot Logo">-->
      <div className="space text-sm font-medium text-expressgray" id="google_translate_element">
        Select your preferred language
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
};
</script>

<style scoped></style>
